import { useMemo } from "react";

export const useCombineLoading = (...loadingStates: boolean[]) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo<boolean>(
        () => loadingStates.some((l) => l === true),
        [loadingStates]
    );
};
